/**
 * Agent mode — enables the AI-agentic-testing APIs (`window.__agentAuthApi`,
 * `window.__agentGameApi`, `window.__agentVoiceApi`).
 *
 * DEV-ONLY: hard-gated on `config.enableDevelop`, so it can never activate on prod builds.
 * Enable by opening the app with `?agentMode=true` (persisted to localStorage for the
 * rest of the browser session) or by setting `localStorage.intraction_agent_mode = 'true'`.
 * Disable with `?agentMode=false`.
 */
import config from '../Config'

export const AGENT_MODE_STORAGE_KEY = 'intraction_agent_mode'

export const isAgentModeEnabled = (): boolean => {
  if (!config.enableDevelop) return false
  if (typeof window === 'undefined') return false
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('agentMode')
    if (fromUrl !== null) {
      window.localStorage.setItem(AGENT_MODE_STORAGE_KEY, fromUrl.toLowerCase() === 'true' ? 'true' : 'false')
    }
    return window.localStorage.getItem(AGENT_MODE_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}
